export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_07.c2748ced.mp4";